import { Navigate } from 'react-router-dom';
import { useWorkspaceStore } from '@/shared/stores/workspaceStore';
import type { ReactNode } from 'react';

interface WorkspaceGuardProps {
  readonly children: ReactNode;
}

export function WorkspaceGuard({ children }: WorkspaceGuardProps) {
  const { selectedWorkspace } = useWorkspaceStore();

  // If no workspace is selected, redirect to workspace list
  if (!selectedWorkspace) {
    return <Navigate to="/workspaces" replace />;
  }

  return <>{children}</>;
}

export default WorkspaceGuard;
